import React from "react";

const LetterIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33398 8.3335L10.084 10.8335L13.834 8.3335"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 17.0002H4.66667C4.22464 17.0002 3.80072 16.8246 3.48816 16.5121C3.17559 16.1995 3 15.7756 3 15.3336V6.66691C3 6.22488 3.17559 5.80096 3.48816 5.4884C3.80072 5.17584 4.22464 5.00024 4.66667 5.00024H15.5C15.942 5.00024 16.366 5.17584 16.6785 5.4884C16.9911 5.80096 17.1667 6.22488 17.1667 6.66691V8.33358"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M5.5 5.00049L15.5003 5.00049C15.9424 5.00049 16.3663 5.17608 16.6788 5.48864C16.9914 5.8012 17.167 6.22513 17.167 6.66716L17.167 15.3338C17.167 15.7758 16.9914 16.1998 16.6788 16.5123C16.3663 16.8249 15.9424 17.0005 15.5003 17.0005L4.66699 17.0005C4.22496 17.0005 3.80104 16.8249 3.48848 16.5123C3.17592 16.1998 3.00033 15.7758 3.00033 15.3338L3.00033 13.6672"
        stroke={color}
        stroke-linecap="round"
      />
    </svg>
  );
};

export default LetterIcon;
